import e from"@emotion/styled";import{setSize as i,setColor as o}from"../../utils/generateStyles.js";const n=e.svg`
  label: spinner;
  animation: spin 1s linear infinite;
  ${r=>i(r.size)}
  ${r=>o(r.color,"color")}
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`,t=e.circle`
  label: spinner-circle;
  stroke: currentColor;
  stroke-dasharray: 50px, 220px;
`;export{t as SpinnerCircleStyled,n as SpinnerStyled};
